﻿export class CompanyModel {
    userPreferenceBasicInfoId: string = '';
    companyName: string = '';
    companyAddress: string = '';
    city: string = '';
    state: string = '';    
    phone: string = '';        
    userId: string = '';
    createdBy: string = '';
    modifiedBy: string = '';
}